/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import L from "./Lang"
import BaseCom from "./BaseCom";
import { Modal } from "react-bootstrap";
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import Globals from "../shared/Globals";

export default class DatePicker extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            dateValue: new Date(),
            showDatePickerModal: false
        };
        this.onChange = this.onChange.bind(this);
        this.onDateClick = this.onDateClick.bind(this);
    }

    componentDidMount() {
        if(this.props.initialDate) {
            this.setState({ dateValue: this.props.initialDate });
        }
    }

    componentDidUpdate(prevProps) {
        if(this.props.initialDate !== prevProps.initialDate) {
            this.setState({ dateValue: this.props.initialDate });
        }
    }

    onDateClick(e) {
        if (e?.target) {
            var dt = null;
            var n = 0;
            var ele = e.target;
            while (ele && ele.tagName && ele.tagName.toUpperCase() !== 'TD' && n < 20) {
                ele = ele.parentElement;
                n++;
            }
            if (!ele || !ele.tagName || ele.tagName.toUpperCase() !== 'TD')
                return;
            var day = ele.querySelector('.fc-daygrid-day-number');
            if (day) {
                dt = day.getAttribute('aria-label');
            }
            this.onChange(new Date(dt));
            this.setState({ showDatePickerModal: false });
        }
    }

    onChange(dt) {
        this.setState({ dateValue: dt });
        this.props.onChange?.(dt);
    }

    render() {
        return <>
            <Modal show={this.state.showDatePickerModal} onHide={() => this.setState({ showDatePickerModal: false })} centered>
                <Modal.Body onClick={this.onDateClick}>
                    <FullCalendar plugins={[dayGridPlugin]} initialView="dayGridMonth" initialDate={this.state.dateValue} events={[
                        {
                            id: 1,
                            title: 'SEL',
                            start: this.state.dateValue,
                            allDay: true
                        }
                    ]}
                        headerToolbar={{
                            left: null,
                            center: "title"
                        }} height={550} />
                </Modal.Body>
            </Modal>
            <input readOnly onClick={() => this.setState({ showDatePickerModal: true })} type="text" className="form-control"
            value={Globals.toMDYLocalDateString(this.state.dateValue)}
            required={this.props.required} placeholder={'MM/dd/yyyy'} disabled={this.props.disabled} autoComplete={false}
            autoFocus={this.props.autoFocus} />
        </>;
    }
}